/* https://jquense.github.io/react-widgets/ */
/* https://www.npmjs.com/package/react-spinners */
/* https://openbase.com/js/react-toastify */

/* popup-ы:  https://openbase.com/categories/js/best-react-notification-libraries?vs=rc-notification%2Creact-toastify%2Cnotistack*/
/* выбранный popup: https://openbase.com/js/react-notification-system/documentation */

import React, { Component } from 'react';

//import NumberPicker from "react-widgets/NumberPicker";
import Combobox from "react-widgets/Combobox";
//import DropdownList from "react-widgets/DropdownList";
//import DatePicker from "react-widgets/DatePicker";
//import Listbox from "react-widgets/Listbox";

import ClipLoader from "react-spinners/ClipLoader";

import { showPopopMessage } from "../../Components/PopupMessage/Toastify.js";
import { TYPE_MESSAGE_EXCEEDS_LENGTH, TYPE_MESSAGE_WRONG_CASE, TYPE_MESSAGE_UNAVAILABLE_SYMBOL } from "../../Components/PopupMessage/Toastify.js";

//import RNSystemSounds from '@dashdoc/react-native-system-sounds';
import { requestBase, apiroot } from "./Fetch-helpers";

export default class UrdUnitFeatureItem extends Component {


    constructor(props) {
        super(props);

        this.state = { urdId: this.props.urdId, unitId: this.props.unitId, tag: this.props.tag };
        this.state = {
            waiting: false, posting: false, id: this.props.feature.id, value: this.props.feature.currentValue,
            timerOn: false, timerDuration: 0, timerTime: 0
        };

        //this.state = {
        //    notification: {} };

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);

        //this.notificationSystem = React.createRef();
    }

    /*maxSize = function (value, maxLength) {
        if (value.length > maxLength) {
            return value.substring(0, maxLength);
        }
    }*/

    /**
     * Таймер
     * 
     */

    startTimer = (msDuration) => {
        this.setState({
            timerOn: true,
            timerTime: 0, //this.state.timerTime,
            timerDuration: msDuration //this.state.timerTime
        });
        this.timer = setInterval(() => {
            const newTime = this.state.timerTime + 10;
            if (newTime < this.state.timerDuration) {
                this.setState({
                    timerTime: newTime
                });
            } else {
                this.stopTimer();
                //alert("Countdown ended");
                this.postData();
            }
        }, 10);
    };
    stopTimer = () => {
        clearInterval(this.timer);
        this.setState({ timerOn: false, timerTime: 0 });
    };
    resetTimer = () => {
        if (this.state.timerOn === true) {
            this.setState({
                timerTime: 0 //this.state.timerStart
            });
        }
    };


    async postDataAsync(tag) {

        console.log("Выполняем PATCH для URD...");
        console.log("Значение: " + tag.currentValue);

        try {
            let response = await fetch(apiroot + "URD"  /*feature.id*/,
                Object.assign({}, requestBase, {
                    method: "PATCH",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json', //, text/plain
                        'Content-Type': 'application/json'//;charset=UTF-8
                    },
                    body: JSON.stringify(tag)
                }));

            if (!response.ok) {

                switch (response.status) {
                    case 599:

                        console.log("Повторно Get Configuration...");
                        await this.props.updateConfiguration(undefined, false, true, false);

                        console.log("Повторно PATCH...");
                        response = await fetch(apiroot + "URD" /*+ (params.cfgid == null ? "" : params.cfgid)*/,
                            Object.assign({}, requestBase, {
                                method: "PATCH",
                                credentials: 'include',
                                headers: {
                                    'Accept': 'application/json', //, text/plain
                                    'Content-Type': 'application/json'//;charset=UTF-8
                                },
                                body: JSON.stringify(tag)
                            }));

                        break;
                    default:
                        const data = await response.json();
                        console.log(JSON.stringify(data));
                        //alert("Какая-то фигня! Смотри консоль...\nЕще можно нажать F5");
                        //this.setState({ posting: false });
                        return;
                }

                if (!response.ok) {
                    const data = await response.json();
                    console.log(JSON.stringify(data));
                    //this.setState({ posting: false });
                    return;
                }
            }

            console.log("PATCH отработал нормально");

            try {
                const data = await response.json();
                this.props.handleUpdate(data);
            }
            finally {
                this.setState({ posting: false });
            }
        }
        catch (err) {
            this.props.showError(err);
        }
    }

    async postDataAsyncTry(feature) {
        try {
            this.props.handleLock(true);
            await this.postDataAsync(feature);
        }
        finally {
            this.props.handleLock(false);
        }
    }

    postData = () => {
        const feature = this.props.feature;

        if (!feature.enable) {
            return;
        }

        feature.configurationId = this.props.configurationId;
        feature.UnitId = this.props.unitId;
        feature.URDId = this.props.urdId;
        //feature.currentValue = this.state.value;

        this.setState({ waiting: false, posting: true });
        this.postDataAsyncTry(feature);
    }

    convert = (value) => {
        const feature = this.props.feature;
        switch (feature.type) {
            case "numericUpDown":
                feature.currentValue = value === null ? '' : String(value);
                break;
            case "textBox":
                feature.currentValue = String(value);
                break;
            case "comboBox":
                feature.values.filter((f) => f.selected == true)[0].selected = false;
                feature.values.filter((f) => f.id == value.id)[0].selected = true;
                break;
            case "dateTime":
                if (value != null && value != '') {
                    var dd = String(value.getDate()).padStart(2, '0');
                    var mm = String(value.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var yyyy = value.getFullYear();
                    feature.currentValue = dd + "." + mm + "." + yyyy;
                } else {
                    feature.currentValue = "";
                }
                break;
            case "radio":
                feature.values.filter((f) => f.selected == true)[0].selected = false;
                feature.values.filter((f) => f.id == value.id)[0].selected = true;
                feature.currentValue = value.description;
                break;
            default:
                feature.currentValue = String(value);
        }

        return feature.currentValue;
    }

    changingValue = (value) => {

        this.setState({ value: this.convert(value), waiting: true });

        if (!this.state.timerOn) {
            this.startTimer(500);
        } else {
            this.resetTimer();
        }
    }

    leavingControl = () => {
        if (this.state.timeron) {
            this.stoptimer();
            this.postdata();
        }
        this.postData();
    }

    validate(event) {
        const feature = this.props.feature;
        const currentValue = event.target.defaultValue;
        const control = event.target;

        if (event.ctrlKey == true || event.altKey == true) return true;

        if (event.key.length == 1) {
            if (feature.characterCount > 0 && currentValue.length >= feature.characterCount) {
                if (control.selectionEnd - control.selectionStart == 0) {
                    //event.preventDefault();
                    showPopopMessage("Максимум символов: " + feature.characterCount, TYPE_MESSAGE_EXCEEDS_LENGTH);
                    return false;
                }
            }
        }

        if (feature.case == 1) {
            if (event.key == event.key.toUpperCase() && event.key != event.key.toLowerCase()) {
                showPopopMessage("Только нижний регистр!", TYPE_MESSAGE_WRONG_CASE);
                return false;
            }
        }
        if (feature.case == 2) {
            if (event.key == event.key.toLowerCase() && event.key != event.key.toUpperCase()) {
                showPopopMessage("Только верхний регистр!", TYPE_MESSAGE_WRONG_CASE);
                return false;
            }
        }
        if (event.key.length == 1 && feature.allowedCharacters != undefined && feature.allowedCharacters != '' && feature.allowedCharacters.indexOf(event.key) === -1) {
            showPopopMessage(<div>Вы ввели недопустимый символ!<p>Разрешенный набор: {`${feature.allowedCharacters}`}</p></div>, TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return false;
        }
        /*this.setState({ value: event.key.toUpperCase() });*/
        return true;
    }

    handleKeyDown(event) {
        const check = this.validate(event);
        if (!check) {
            event.preventDefault();
        }
    }

    handleChange(newValue) {
        /*const check = this.validate(event);
        if (!check) {
            event.preventDefault();
        }*/

        const feature = this.props.feature;
        let check = true;

        if (newValue.length > 0) {
            if (feature.characterCount > 0 && newValue.length > feature.characterCount) {
                showPopopMessage("Максимум символов: " + feature.characterCount, TYPE_MESSAGE_EXCEEDS_LENGTH);
                return;
            }
            if (feature.case == 1) {
                for (var i = 0; i < newValue.length; i++) {
                    if (newValue[i] == newValue[i].toUpperCase() && newValue[i] != newValue[i].toLowerCase()) {
                        showPopopMessage("Только нижний регистр!", TYPE_MESSAGE_WRONG_CASE);
                        //return false;
                        check = false;
                    }
                }
            }
            if (feature.case == 2) {
                for (var i = 0; i < newValue.length; i++) {
                    if (newValue[i] == newValue[i].toLowerCase() && newValue[i] != newValue[i].toUpperCase()) {
                        // чтобы не дублировать однотипное сообщение, проверяем - была ли уже проблема с TYPE_MESSAGE_WRONG_CASE
                        if (check) {
                            showPopopMessage("Только верхний регистр!", TYPE_MESSAGE_WRONG_CASE);
                        }
                        //return false;
                        check = false;
                    }
                }
            }
            for (var i = 0; i < newValue.length; i++) {
                if (feature.allowedCharacters != undefined && feature.allowedCharacters != '' && feature.allowedCharacters.indexOf(newValue[i]) === -1) {
                    showPopopMessage(<div>Вы ввели недопустимый символ!<p>Разрешенный набор: {`${feature.allowedCharacters}`}</p></div>, TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
                    //return false;
                    check = false;
                }
            }
        }

        if (!check) return false;

        this.setState({ value: this.convert(newValue), waiting: true });

        if (!this.state.timerOn) {
            this.startTimer(500);
        } else {
            this.resetTimer();
        }

    }

    render() {
        const feature = this.props.feature;
        const autoSize = this.props.autoSize;
        const enable = this.props.extDisable ? false : feature.enable;

        var title = "Маскимальное количество символов: " + feature.characterCount;
        if (feature.allowedCharacters != undefined && feature.allowedCharacters != '') {
            title = title + "\nДопустимый набор символов: " + feature.allowedCharacters;
        }
        if (feature.case != undefined && feature.case == 1) {
            title = title + "\nТолько нижний регистр!";
        }
        if (feature.case != undefined && feature.case == 2) {
            title = title + "\nТолько ВЕРХНИЙ регистр!";
        }

        let titleValue = "";
        let titleStatus = "";

        const colorLoader = "white";
        let colorStatusClass = "";
        if (this.state.waiting) {
            colorStatusClass = "yellowlightOptFea";
            titleStatus = "";
        }
        if (this.state.posting) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр в процессе сохранения...";
        }
        if (!enable) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр недоступен для редактирования";
        } else {
            if (colorStatusClass == "") {
                colorStatusClass = feature.validate === true ? "grnOptFea" : "redOptFea";
                titleStatus = feature.validate === true ? "Параметр введен корректно" : "Значение параметра введено неверно";
            }
        }

        var style = {
            NotificationItem: { // Override the notification item
                DefaultStyle: { // Applied to every notification, regardless of the notification level
                    margin: '10px 5px 2px 1px'
                },

                error: {

                    fontSize: '18px',
                    color: 'black'
                }
            }
        }

        return (
            <div class="cdsFeatureItemHeaderComment" >
                {feature.description}
                <table>
                    <tbody>
                        <tr>
                            <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                    <ClipLoader id={`${colorStatusClass}`}
                                        color={colorLoader}
                                        loading={this.state.posting}
                                        //cssOverride={override}
                                        size="12px"
                                        speedMultiplier="0.7"
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                </div>
                            </td>
                            <td className="urdCell" title={title} >
                                <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                    <Combobox
                                        placeholder={feature.placeholder}
                                        hideCaret
                                        hideEmptyPopup
                                        /*defaultValue={feature.currentValue}*/
                                        value={this.props.feature.enable ? this.state.value : this.props.feature.currentValue} //{this.state.value}
                                        /*onChange={value => this.postData(line.lineId, value)}*/
                                        /*onChange={(nextValue) => nextValue = nextValue.toUpperCase()}*/
                                        /*value={this.state.value}*/
                                        onChange={this.handleChange}
                                        onKeyDown={this.handleKeyDown}
                                        /*onChange={value => this.changeTag(line.lineId, value)}*/
                                        /*onBlur={value => this.postData(feature.id, value.target.value)}*/
                                        //onChange={value => this.changingValue(value)}
                                        onBlur={value => this.leavingControl()}
                                        /*maxLength={2}*/
                                        name={feature.id}
                                        readOnly={!enable}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {/*<NotificationSystem ref={this.notificationSystem} style={style} />*/}
            </div>
        );
    }
}